import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { GA4_APP_PLAY_GAME_EVENT } from "@/feature-analytics/google.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export async function onEnterValGame(payload) {
  refs.gtag("event", GA4_APP_PLAY_GAME_EVENT, {
    ...(await refs.getIdentifyingInfo()),
    game: "val",
  });

  return refs.trackEvent(ANALYTIC_EVENTS.VAL_START, payload);
}

export function onExitValGame(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.VAL_END, payload);
}

export function onLoadedValLoadingScreen({ duration }) {
  return refs.trackEvent(ANALYTIC_EVENTS.VAL_LOADING_SCREEN, { duration });
}

export function onMatchStats(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.VAL_MATCH_REVERSED_STATS, payload);
}
